// extracted by mini-css-extract-plugin
export default {"container":"StudentListTable_container__ndgFq","scrollWrapper":"StudentListTable_scrollWrapper__a0mx9","listContainer":"StudentListTable_listContainer__dqtZf"};